// Module
var code = `<div class="explorer-backdrop"></div>
<div class="explorer-panel">
  <div class="explorer-header">
    <div class="explorer-header-top">
      <span class="explorer-title">Widget Builder</span>
      <button id="active-source-crumb" class="source-crumb hidden" type="button" title="Click to go back to source selection"></button>
      <div class="header-actions">
        <hs-toolbar-button id="run-btn" title="Run"></hs-toolbar-button>
        <hs-toolbar-button id="export-btn" title="Export"></hs-toolbar-button>
        <hs-toolbar-button id="close-btn" title="✕"></hs-toolbar-button>
      </div>
    </div>
    <nav id="step-nav" class="step-nav">
      <button class="step-tab active" data-step="source" type="button"><span class="step-num">1</span> Source</button>
      <button class="step-tab" data-step="fields" type="button" disabled><span class="step-num">2</span> Fields</button>
      <button class="step-tab" data-step="time" type="button" disabled><span class="step-num">3</span> Time</button>
      <button class="step-tab" data-step="transform" type="button" disabled><span class="step-num">4</span> Transform</button>
      <button class="step-tab" data-step="visualize" type="button" disabled><span class="step-num">5</span> Visualize</button>
      <button class="step-tab" data-step="customize" type="button" disabled><span class="step-num">6</span> Customize</button>
      <button class="step-tab" data-step="output" type="button" disabled><span class="step-num">7</span> Output</button>
    </nav>
    <div id="step-instruction" class="step-instruction">Choose the primary data source for this widget.</div>
  </div>

  <div class="explorer-body">
    <!-- Step panels -->
    <div class="step-panels">
      <!-- Step 1: Source -->
      <div id="step-source" class="step-panel active">
        <div class="step-panel-content">
          <button type="button" id="source-picker-trigger" class="source-picker-trigger">
            <span id="source-picker-trigger-text" class="source-picker-trigger-text">Choose data source…</span>
          </button>
          <div id="source-loading-indicator" class="source-loading-indicator hidden">
            <span class="spinner"></span>
            <span id="source-loading-text">Loading…</span>
          </div>
          <div id="auto-defaults" class="auto-defaults hidden"></div>
        </div>
        <div class="step-actions">
          <span></span>
          <hs-toolbar-button id="step-next-source" title="Next: Fields →" disabled></hs-toolbar-button>
        </div>
      </div>

      <!-- Step 2: Fields + Adornments -->
      <div id="step-fields" class="step-panel hidden">
        <div class="step-panel-content">
          <div id="fields-section" class="builder-section">
            <div class="section-title">
              <span>Fields</span>
              <span class="section-actions">
                <button id="fields-mode-auto-btn" class="link-btn" title="Show fields with observed values from sampled rows plus required and key fields">auto fields</button>
                <span class="section-actions-sep">/</span>
                <button id="fields-mode-all-btn" class="link-btn">all fields</button>
                <span class="section-actions-sep">/</span>
                <button id="fields-all-btn" class="link-btn">all</button>
                <span class="section-actions-sep">/</span>
                <button id="fields-none-btn" class="link-btn">none</button>
              </span>
            </div>
            <input type="text" id="field-search" class="field-search-input" placeholder="Filter fields..." />
            <div id="field-list" class="field-list"></div>
          </div>
          <div id="adornment-section" class="builder-section">
            <div class="section-title">
              <span>Adornments (related sources)</span>
              <button id="add-adornment-btn" class="link-btn">+ add</button>
            </div>
            <div id="adornment-list" class="adornment-list"></div>
          </div>
          <div id="join-fields-section" class="builder-section hidden">
            <div class="section-title">
              <span>Join-only Fields</span>
              <span class="section-hint">(used for adornment keys, not in final output)</span>
            </div>
            <div id="join-fields-list" class="join-fields-list"></div>
          </div>
        </div>
        <div class="step-actions">
          <hs-toolbar-button id="step-prev-fields" title="← Source"></hs-toolbar-button>
          <hs-toolbar-button id="step-next-fields" title="Next: Visualize →"></hs-toolbar-button>
        </div>
      </div>

      <!-- Step 3: Time -->
      <div id="step-time" class="step-panel hidden">
        <div class="step-panel-content">
          <div id="time-not-applicable" class="step-hint hidden">No time field detected for this source. Time filtering is not available.</div>

          <!-- Quick presets for non-time-series sources (telemetry/state) -->
          <div id="time-recency-section" class="builder-section hidden">
            <div class="section-title">Show recent activity</div>
            <div class="step-hint">Limit results to entries with recent timestamps.</div>
            <div class="time-preset-grid">
              <button type="button" class="time-preset-btn" data-hours="1">Last hour</button>
              <button type="button" class="time-preset-btn" data-hours="6">Last 6 hours</button>
              <button type="button" class="time-preset-btn active" data-hours="24">Last 24 hours</button>
              <button type="button" class="time-preset-btn" data-hours="168">Last 7 days</button>
              <button type="button" class="time-preset-btn" data-hours="720">Last 30 days</button>
              <button type="button" class="time-preset-btn" data-hours="0">All time</button>
            </div>
          </div>

          <!-- TimeScope selection for rollup/journal sources -->
          <div id="time-timescope-section" class="builder-section hidden">
            <div class="section-title">Time scope</div>
            <div class="step-hint">Choose the time window for this time-series source.</div>
            <div class="time-preset-grid">
              <button type="button" class="time-scope-btn" data-scope="day">Day</button>
              <button type="button" class="time-scope-btn active" data-scope="week">Week</button>
              <button type="button" class="time-scope-btn" data-scope="month">Month</button>
              <button type="button" class="time-scope-btn" data-scope="quarter">Quarter</button>
            </div>
            <div class="granularity-control" id="granularity-control">
              <label class="time-label">Granularity</label>
              <select id="granularity-select" class="granularity-select">
                <option value="">Auto-detected</option>
                <option value="hourly">Hourly</option>
                <option value="daily">Daily</option>
                <option value="monthly">Monthly</option>
                <option value="quarterly">Quarterly</option>
              </select>
            </div>
          </div>

          <!-- Custom date/time picker (collapsed by default) -->
          <details id="time-custom-section" class="time-custom-details">
            <summary class="time-custom-summary">Custom date range</summary>
            <div class="time-custom-body">
              <label class="time-label">From</label>
              <input type="datetime-local" id="start-time" class="time-input" />
              <label class="time-label">To</label>
              <input type="datetime-local" id="end-time" class="time-input" />
            </div>
          </details>
        </div>
        <div class="step-actions">
          <hs-toolbar-button id="step-prev-time" title="← Fields"></hs-toolbar-button>
          <hs-toolbar-button id="step-next-time" title="Next: Visualize →"></hs-toolbar-button>
        </div>
      </div>

      <!-- Step 4: Transform (Filters + Aggregation + GroupBy) -->
      <div id="step-transform" class="step-panel hidden">
        <div class="step-panel-content">
          <div id="filters-section" class="builder-section">
            <div class="section-title">
              <span>Filters</span>
              <span class="section-actions">
                <button id="clear-filters-btn" class="link-btn">clear</button>
                <span class="section-actions-sep">/</span>
                <button id="add-filter-btn" class="link-btn">+ add</button>
              </span>
            </div>
            <div id="filter-list" class="filter-list"></div>
          </div>
          <div id="aggregation-section" class="builder-section">
            <div class="section-title">Aggregation</div>
            <div class="aggr-controls">
              <select id="aggr-op">
                <option value="">None</option>
                <option value="count">Count rows</option>
                <option value="sum">Sum field</option>
                <option value="avg">Average field</option>
                <option value="min">Min field</option>
                <option value="max">Max field</option>
              </select>
              <select id="aggr-field" class="hidden"></select>
            </div>
          </div>
          <div id="groupby-section" class="builder-section">
            <div class="section-title">
              <span>Group By</span>
              <button id="add-groupby-btn" class="link-btn">+ add</button>
            </div>
            <div id="groupby-list" class="groupby-list"></div>
          </div>
        </div>
        <div class="step-actions">
          <hs-toolbar-button id="step-prev-transform" title="← Fields"></hs-toolbar-button>
          <hs-toolbar-button id="step-next-transform" title="Next: Visualize →"></hs-toolbar-button>
        </div>
      </div>

      <!-- Step 5: Visualize -->
      <div id="step-visualize" class="step-panel hidden">
        <div class="step-panel-content">

          <div id="viz-section" class="builder-section">
            <div class="section-title">Visualization Type</div>
            <div class="viz-type-grid">
              <button class="viz-type-btn active" data-viz="table" type="button">
                <span class="viz-type-icon">&#9638;</span><span class="viz-type-label">Table</span>
              </button>
              <button class="viz-type-btn" data-viz="line" type="button">
                <span class="viz-type-icon">&#9585;</span><span class="viz-type-label">Line Chart</span>
              </button>
              <button class="viz-type-btn" data-viz="bar" type="button">
                <span class="viz-type-icon">&#9612;</span><span class="viz-type-label">Bar Chart</span>
              </button>
              <button class="viz-type-btn" data-viz="metric" type="button">
                <span class="viz-type-icon">#</span><span class="viz-type-label">Metric</span>
              </button>
            </div>
          </div>
          <div id="viz-axis-section" class="builder-section hidden">
            <div class="section-title">Axis Mapping</div>
            <div class="axis-controls">
              <div class="axis-row">
                <label class="axis-label">X-Axis</label>
                <select id="viz-x-axis" class="axis-select"></select>
              </div>
              <div class="axis-row">
                <label class="axis-label">Y-Axis</label>
                <select id="viz-y-axis" class="axis-select" multiple></select>
              </div>
            </div>
          </div>
          <div id="viz-metric-section" class="builder-section hidden">
            <div class="section-title">Metric Field</div>
            <div class="axis-controls">
              <div class="axis-row">
                <label class="axis-label">Value Field</label>
                <select id="viz-metric-field" class="axis-select"></select>
              </div>
              <div class="axis-row">
                <label class="axis-label">Title</label>
                <input type="text" id="viz-metric-title" class="axis-input" placeholder="Widget title" />
              </div>
              <div class="axis-row">
                <label class="axis-label">Suffix</label>
                <input type="text" id="viz-metric-suffix" class="axis-input" placeholder="e.g. Total, Active" />
              </div>
            </div>
          </div>
        </div>
        <div class="step-actions">
          <hs-toolbar-button id="step-prev-visualize" title="← Fields"></hs-toolbar-button>
          <hs-toolbar-button id="step-next-visualize" title="Next: Customize →"></hs-toolbar-button>
        </div>
      </div>

      <!-- Step 6: Customize -->
      <div id="step-customize" class="step-panel hidden">
        <div class="step-panel-content">
          <div id="customize-section" class="builder-section">
            <div class="section-title">Display Options</div>
            <div class="customize-grid">
              <div class="customize-row">
                <label class="customize-label">Widget Title</label>
                <input type="text" id="custom-title" class="customize-input" placeholder="Optional widget title" />
              </div>
              <div class="customize-row">
                <label class="customize-label">Width (grid units)</label>
                <input type="number" id="custom-width" class="customize-input" min="1" max="12" value="12" />
              </div>
              <div class="customize-row">
                <label class="customize-label">Height (grid units)</label>
                <input type="number" id="custom-height" class="customize-input" min="1" max="12" value="4" />
              </div>
              <div class="customize-row">
                <label class="customize-label">Exportable</label>
                <select id="custom-exportable" class="customize-select">
                  <option value="yes" selected>Yes</option>
                  <option value="no">No</option>
                </select>
              </div>
              <div class="customize-row">
                <label class="customize-label">Search</label>
                <select id="custom-search" class="customize-select">
                  <option value="no" selected>Disabled</option>
                  <option value="yes">Enabled</option>
                </select>
              </div>
            </div>
          </div>
          <div id="customize-table-section" class="builder-section hidden">
            <div class="section-title">
              <span>Column Configuration</span>
              <button id="reset-col-config-btn" class="link-btn" title="Reset column configs from active fields">reset</button>
            </div>
            <div id="col-config-list" class="col-config-list"></div>
            <div class="customize-grid" style="margin-top: 12px;">
              <div class="customize-row">
                <label class="customize-label">Default Sort Column</label>
                <select id="custom-sort-col" class="customize-select"></select>
              </div>
              <div class="customize-row">
                <label class="customize-label">Sort Direction</label>
                <select id="custom-sort-dir" class="customize-select">
                  <option value="asc">Ascending</option>
                  <option value="desc">Descending</option>
                </select>
              </div>
            </div>
          </div>
          <div id="customize-chart-section" class="builder-section hidden">
            <div class="section-title">Chart Options</div>
            <div class="customize-grid">
              <div class="customize-row">
                <label class="customize-label">Legend</label>
                <select id="custom-legend" class="customize-select">
                  <option value="auto">Auto</option>
                  <option value="show">Show</option>
                  <option value="hide">Hide</option>
                </select>
              </div>
              <div class="customize-row">
                <label class="customize-label">Tooltip</label>
                <select id="custom-tooltip" class="customize-select">
                  <option value="axis">Axis (crosshair)</option>
                  <option value="item">Item (point)</option>
                  <option value="none">None</option>
                </select>
              </div>
              <div class="customize-row">
                <label class="customize-label">Smooth Lines</label>
                <select id="custom-smooth" class="customize-select">
                  <option value="yes" selected>Yes</option>
                  <option value="no">No</option>
                </select>
              </div>
              <div class="customize-row">
                <label class="customize-label">Show Data Points</label>
                <select id="custom-show-symbols" class="customize-select">
                  <option value="auto" selected>Auto (&lt;100 points)</option>
                  <option value="yes">Always</option>
                  <option value="no">Never</option>
                </select>
              </div>
              <div class="customize-row">
                <label class="customize-label">Y-Axis Label Names</label>
                <input type="text" id="custom-y-labels" class="customize-input" placeholder="Comma-separated labels for each Y series" />
              </div>
            </div>
          </div>
          <div id="customize-metric-section" class="builder-section hidden">
            <div class="section-title">Metric Options</div>
            <div class="customize-grid">
              <div class="customize-row">
                <label class="customize-label">Value Formatter</label>
                <select id="custom-metric-formatter" class="customize-select">
                  <option value="">None (raw value)</option>
                  <option value="duration_hm">Duration (hours/mins)</option>
                </select>
              </div>
              <div class="customize-row">
                <label class="customize-label">Icon</label>
                <select id="custom-metric-icon" class="customize-select">
                  <option value="">None</option>
                  <option value="calls">Calls</option>
                  <option value="tasks">Tasks</option>
                  <option value="media">Media</option>
                  <option value="accounts">Accounts</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="step-actions">
          <hs-toolbar-button id="step-prev-customize" title="← Visualize"></hs-toolbar-button>
          <hs-toolbar-button id="step-next-customize" title="Next: Output →"></hs-toolbar-button>
        </div>
      </div>

      <!-- Step 7: Output -->
      <div id="step-output" class="step-panel hidden">
        <div class="step-panel-content">
          <div id="output-timescope-section" class="builder-section hidden">
            <div class="section-title">Time Scope Options</div>
            <div class="step-hint">This source supports time-series data. Enable timeScope switching to generate a dynamic path template.</div>
            <div class="customize-grid">
              <div class="customize-row">
                <label class="customize-label">Dynamic timeScope path</label>
                <select id="output-timescope-toggle" class="customize-select">
                  <option value="yes" selected>Yes — use template expression</option>
                  <option value="no">No — use fixed path</option>
                </select>
              </div>
              <div class="customize-row">
                <label class="customize-label">Allowed Time Scopes</label>
                <select id="output-timescopes" class="customize-select" multiple size="5">
                  <option value="day" selected>Day</option>
                  <option value="week" selected>Week</option>
                  <option value="month" selected>Month</option>
                  <option value="quarter">Quarter</option>
                  <option value="all">All</option>
                </select>
              </div>
            </div>
          </div>
          <div id="output-section" class="builder-section">
            <div class="section-title">
              <span>Card Configuration</span>
              <button id="copy-config-btn" class="link-btn">Copy JSON</button>
            </div>
            <pre id="output-config" class="output-config"></pre>
          </div>
        </div>
        <div class="step-actions">
          <hs-toolbar-button id="step-prev-output" title="← Customize"></hs-toolbar-button>
          <span></span>
        </div>
      </div>
    </div>

    <!-- Preview area (always visible) -->
    <div class="explorer-results">
      <div class="results-bar">
        <span id="results-count" class="results-count"></span>
        <span id="status-bar" class="status-bar">Select a data source to begin</span>
        <div class="results-view-toggle">
          <button id="results-view-card-btn" class="toggle-btn active" type="button" aria-pressed="true">Card</button>
          <button id="results-view-json-btn" class="toggle-btn" type="button" aria-pressed="false">JSON</button>
          <button id="results-view-schema-btn" class="toggle-btn" type="button" aria-pressed="false">Schema</button>
          <button id="results-view-config-btn" class="toggle-btn" type="button" aria-pressed="false">Config</button>
        </div>
        <button id="results-copy-json-btn" class="btn btn-secondary json-copy-btn" type="button" title="Copy current JSON rows to clipboard">Copy JSON</button>
        <code id="query-display" class="query-display"></code>
      </div>
      <div id="table-target" class="table-target"></div>
      <div id="chart-preview-target" class="chart-preview-target hidden"></div>
      <div id="metric-preview-target" class="metric-preview-target hidden"></div>
      <div id="json-target" class="json-target hidden"></div>
      <div id="schema-target" class="schema-target hidden">
        <div class="schema-toolbar">
          <div class="schema-view-toggle">
            <button id="schema-view-summary-btn" class="toggle-btn active" type="button" aria-pressed="true">Summary</button>
            <button id="schema-view-effective-json-btn" class="toggle-btn" type="button" aria-pressed="false">Effective JSON</button>
            <button id="schema-view-original-json-btn" class="toggle-btn" type="button" aria-pressed="false">Original JSON</button>
          </div>
          <button id="schema-copy-effective-btn" class="btn btn-secondary schema-copy-btn" type="button" title="Copy current effective schema JSON payload">Copy Effective JSON</button>
          <button id="schema-copy-original-btn" class="btn btn-secondary schema-copy-btn" type="button" title="Copy original schema JSON payload">Copy Original JSON</button>
        </div>
        <div id="schema-summary-content" class="schema-summary-content"></div>
        <div id="schema-json-content" class="schema-json-content hidden"></div>
      </div>
      <div id="config-target" class="config-target hidden">
        <div class="config-toolbar">
          <button id="config-copy-btn" class="btn btn-secondary" type="button" title="Copy card config JSON to clipboard">Copy Config</button>
        </div>
        <pre id="config-output" class="config-output"></pre>
      </div>
    </div>
  </div>
</div>

<!-- Hidden sidebar for controls-modal compatibility -->
<div id="explorer-sidebar" class="explorer-sidebar hidden"></div>

<div id="controls-modal" class="provider-picker-modal hidden">
  <div class="provider-picker-backdrop"></div>
  <div class="provider-picker-dialog controls-modal-dialog" role="dialog" aria-modal="true" aria-label="Explorer controls">
    <div class="controls-modal-header">
      <div class="provider-picker-title" id="controls-modal-title">Explorer controls</div>
      <button id="controls-modal-close" class="btn btn-icon controls-modal-close" type="button" title="Close controls">&#x2715;</button>
    </div>
    <div id="controls-modal-content" class="controls-modal-content"></div>
  </div>
</div>

<div id="provider-picker-modal" class="provider-picker-modal hidden">
  <div class="provider-picker-backdrop"></div>
  <div class="provider-picker-dialog" role="dialog" aria-modal="true" aria-label="Choose providers">
    <div class="provider-picker-title" id="provider-picker-title">Choose providers</div>
    <div class="provider-picker-subtitle">Use Cmd/Ctrl-click to choose multiple values.</div>
    <select id="provider-picker-select" class="provider-picker-select" multiple></select>
    <div class="provider-picker-actions">
      <button id="provider-picker-cancel" class="btn btn-secondary" type="button">Cancel</button>
      <button id="provider-picker-apply" class="btn btn-primary" type="button">Apply</button>
    </div>
  </div>
</div>

<div id="adorn-shortcut-menu" class="adorn-shortcut-menu hidden"></div>

<div id="adorn-key-mapping-modal" class="provider-picker-modal hidden">
  <div class="provider-picker-backdrop"></div>
  <div class="source-picker-modal-dialog" role="dialog" aria-modal="true" aria-label="Configure adornment key mapping">
    <div class="source-picker-modal-header">
      <div class="provider-picker-title" id="adorn-key-mapping-title">Configure Key Mapping</div>
      <button id="adorn-key-mapping-close" class="btn btn-icon" type="button" title="Close">&#x2715;</button>
    </div>
    <div class="adorn-key-mapping-body">
      <div class="adorn-key-mapping-hint">
        Map each key field from the adorning source to a corresponding field available in the primary query results.
        The adorning source's primary key determines which fields are required for an efficient join.
      </div>
      <div id="adorn-key-mapping-rows" class="adorn-key-mapping-rows"></div>
    </div>
    <div class="provider-picker-actions">
      <button id="adorn-key-mapping-cancel" class="btn btn-secondary" type="button">Cancel</button>
      <button id="adorn-key-mapping-apply" class="btn btn-primary" type="button">Apply</button>
    </div>
  </div>
</div>

<div id="adorn-field-picker-modal" class="provider-picker-modal hidden">
  <div class="provider-picker-backdrop"></div>
  <div class="provider-picker-dialog" role="dialog" aria-modal="true" aria-label="Choose adorn fields">
    <div class="provider-picker-title" id="adorn-field-picker-title">Choose adorn fields</div>
    <div class="provider-picker-subtitle">Use Cmd/Ctrl-click to choose multiple fields from the adorn source.</div>
    <select id="adorn-field-picker-select" class="provider-picker-select" multiple></select>
    <div class="provider-picker-actions">
      <button id="adorn-field-picker-cancel" class="btn btn-secondary" type="button">Cancel</button>
      <button id="adorn-field-picker-apply" class="btn btn-primary" type="button">Apply</button>
    </div>
  </div>
</div>
`;
// Exports
export default code;